import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AlertService } from '@context/frontend/alert';
import { Chemical } from '@context/shared/types/chemical';
import { DocumentReference } from 'firebase/firestore';
import { ChemicalService } from '../services';

type ChemicalResolveData = {
	data: Chemical;
	ref: DocumentReference<Chemical>;
};

@Injectable({ providedIn: 'root' })
export class ChemicalDetailResolver implements Resolve<ChemicalResolveData | null> {
	readonly chemicalService = inject(ChemicalService);
	readonly router = inject(Router);
	readonly alert = inject(AlertService);

	async resolve(route: ActivatedRouteSnapshot): Promise<ChemicalResolveData> {
		const id = route.paramMap.get('id');
		if (!id) return this.redirect();

		const snapshot = await this.chemicalService
			.findById(id)
			.catch(() => this.redirect());

		return {
			ref: snapshot.ref,
			data: snapshot.data() as Chemical,
		};
	}

	readonly redirect = () =>
		this.router.navigate(['/chemicals']).then(() => {
			this.alert.open('generic-error').subscribe();
			return Promise.reject();
		});
}
